"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SourcesButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const store_1 = require("../../store");
const document_1 = require("../../slices/document");
const colors_1 = require("../../common/colors");
const AppText_1 = require("../AppText");
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
;
function SourcesButton({ document }) {
    const dispatch = (0, store_1.useAppDispatch)();
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const handlePress = (0, react_1.useCallback)(() => {
        dispatch((0, document_1.toggleSourcesOpen)());
    }, [dispatch]);
    return ((0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: "View Sources", children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { style: [styles.container, isHovered && { opacity: 0.7 }], onPress: handlePress, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faBook, size: 24, color: colors_1.Colors.white }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: [styles.counterContainer], children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.counterText, children: document.files?.length ?? 1 }) })] }) }));
}
const styles = react_native_1.StyleSheet.create({
    container: {
        padding: 4,
    },
    counterContainer: {
        backgroundColor: colors_1.Colors.CTA_CTA,
        width: 14,
        height: 14,
        position: 'absolute',
        top: 0,
        right: 0,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 7,
    },
    counterText: {
        color: colors_1.Colors.NEUTRAL_100,
        fontSize: 10,
        fontWeight: '600',
        lineHeight: 12,
    },
});
